module.exports = __webpack_public_path__ + "img/img_sv_guide_02.101906ed.png";